import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/common/ErrorBoundary';
import reportWebVitals from './reportWebVitals';

// One entry for both targets. App itself decides what to render based on
// IS_DESKTOP (REACT_APP_TARGET=desktop for the Hostinger build, or
// ?desktop=1 to preview on any build):
//   • mobile build  → the 430px app (Render + Capacitor) — unchanged
//   • desktop build → ProRentz marketing site when logged out,
//                      sidebar dashboard chrome when logged in
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
